import { Coordinate } from "./coordinate";

export class CoordinateTransform extends  Coordinate{
  EPSGin:number;
  EPSGout:number; 
  }
  